<template>
    <div>
        <fluke-card>
            <header>
                <div class="title">
                    Requisições de dados
                </div>
                <div class="description">
                    Lista de requisições feitas.
                </div>
            </header>
            <main>
                <h2>Esperando ação</h2>

                <v-data-table
                    :headers="requests.tableHeaders"
                    :items="requests.waiting"
                    :rows-per-page-items="[5,10,20]"
                    rows-per-page-text="Linhas pos página"
                    class="inner-tables">

                    <template v-slot:items="props">
                        <td v-on:click="edit(props.item.id)">{{ props.item.id }}</td>
                        <td v-on:click="edit(props.item.id)">{{ props.item.email }}</td>
                        <td v-on:click="edit(props.item.id)">{{ props.item.cnpj }}</td>
                        <td v-on:click="edit(props.item.id)">{{ props.item.createdAt }}</td>
                    </template>
                </v-data-table>


                <h2>Antigas</h2>

                <v-data-table
                    :headers="requests.tableHeaders"
                    :items="requests.olds"
                    :rows-per-page-items="[5,10,20]"
                    rows-per-page-text="Linhas pos página"
                    class="inner-tables">

                    <template v-slot:items="props">
                        <td v-on:click="edit(props.item.id)">{{ props.item.id }}</td>
                        <td v-on:click="edit(props.item.id)">{{ props.item.email }}</td>
                        <td v-on:click="edit(props.item.id)">{{ props.item.cnpj }}</td>
                        <td v-on:click="edit(props.item.id)">{{ props.item.createdAt }}</td>
                    </template>
                </v-data-table>
            </main>
        </fluke-card>

        <fluke-card>
            <header>
                <div class="title">
                    Estudantes Certificados
                </div>
                <div class="description">
                    Lista de estudantes que já concluíram o curso.
                </div>
            </header>
            <main>
                <v-data-table
                    :headers="students.tableHeaders"
                    :items="students.list"
                    :search="search"
                    :rows-per-page-items="[15,30,60]"
                    rows-per-page-text="Linhas pos página"
                    class="inner-tables"
                    ref="seliga">

                    <template v-slot:items="props">
                        <td v-on:click="editStudent(props.item.id)">{{ props.item.id }}</td>
                        <td v-on:click="editStudent(props.item.id)">{{ props.item.name }}</td>
                        <td v-on:click="editStudent(props.item.id)">{{ props.item.course }}</td>
                    </template>

                    <template v-slot:no-results>
						<v-alert
							:value="true"
							color="error"
							icon="warning">
							Sua busca por "{{ search }}" não achou nenhum resultado.
						</v-alert>
					</template>
                </v-data-table>

                <div class="flexsplit">
					<div class="searchtable">
						<v-text-field
							v-model="search"
							append-icon="search"
							label="Pesquise"
							single-line
							hide-details>
						</v-text-field>
					</div>
                    <div></div>
				</div>
            </main>
            <footer v-if="permission.write">
                <fluke-button v-on:click.native="addStudent">Adicionar Individual</fluke-button>
                <fluke-button v-on:click.native="select">Adicionar Nova Base</fluke-button>
                <download-excel
					class   = "fluke-btn export-btn"
					:data   = "searchItems"
					:fields = "json_fields"
					worksheet = "Alunos Certificados Worksheet"
					name    = "alunos.xls">

					<i class="material-icons">get_app</i>
					Download XLS

				</download-excel>
            </footer>
        </fluke-card>

        <input
            type="file"
            ref="ig_inputfile"
            class="ig_inputfile"
            @change="setFromPc">
    </div>
</template>

<style lang="scss">
.ig_inputfile { display: none; }
</style>

<script>
import permission from '../../mixins/permissions';
import axios from 'axios';
import Card from '../../components/Main/Content/Card/Card.vue';
import Button from '../../components/Main/Content/Button/Button.vue';
import moment from 'moment';


export default {
    mixins: [ permission ],
    components: {
		'fluke-card': Card,
		'fluke-button': Button
	},
    data()
    {
        return {
            search: '',
            selected_filter: [],
            json_fields: {
				'dbID': 'id',
				'Nome': 'name',
				'Curso': 'course',
				'Conclusão': 'conclusion_year',
				'Cidade': 'city',
				'Estado': 'state',
				'Instrutor': 'instructor',
			},
            students: {
                tableHeaders: [
                    {
                        text: "ID",
                        align: 'left',
                        value: 'id'
                    },
                    {
                        text: "Nome",
                        align: 'left',
                        value: 'name'
                    },
                    {
                        text: "Curso",
                        align: 'left',
                        value: 'course'
                    }
                ],
                list: [],
            },
            requests: {
                tableHeaders: [
                    {
                        text: "ID",
                        align: 'left',
                        value: 'id'
                    },
                    {
                        text: "Email",
                        align: 'left',
                        value: 'email'
                    },
                    {
                        text: "CNPJ",
                        align: 'left',
                        value: 'cnpj'
                    },
                    {
                        text: "Data",
                        align: 'left',
                        value: 'orignalCreatedAt'
                    }
                ],
                waiting: [],
                olds: []
            },
            searchItems: []
        }
    },
    watch: {
        search()
        {
            if( this.search == '' ) this.searchItems =  this.$refs.seliga.items;
            else this.searchItems = this.customFilter( this.search, this.$refs.seliga.items );
        }
    },
    created () {
        this.get();
        this.getRequests();
		this.permission = this.getUserPagePermission('students');
		if( this.permission.read == false ) {
			this.$router.push('/');
		}
    },
    methods: {
        filter(val, search) {
            return (
                val !== null &&
                ['undefined', 'boolean'].indexOf(typeof val) === -1 &&
                val.toString().toLowerCase().indexOf(search) !== -1
            )
        },
        customFilter(search, items) {
            search = search.toString().toLowerCase()
            return items.filter(i => (
                Object.keys(i).some(j => this.filter(i[j], search))
            ))
        },
        async get() {
			const result = await axios.get(
                this.$myServerAddresses.courses + 'students',
                {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );
            this.students.list = result.data;
        },
        async getRequests() {
			const result = await axios.get(
                this.$myServerAddresses.courses + 'students/request',
                {
                headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );
            var custom_fields = {};
            result.data.forEach( item => {
                item.orignalCreatedAt = item.createdAt;
                item.createdAt = moment( item.createdAt ).format( 'DD/MM/YYYY' );

                custom_fields = JSON.parse( item.custom_fields );
                item.cnpj = custom_fields.cnpj;
                item['read'] = ( typeof custom_fields.read != 'undefined' )?custom_fields.read:false;

                if( item.read ) this.requests.olds.push( item );
                else this.requests.waiting.push( item );
            });
        },
        edit( reqID )
        {
            this.$router.push({
                name: 'students-request-edit',
                params: {
                    id: reqID
                }
            });
        },
        addStudent()
        {
            this.$router.push({
                name: 'students-add'
            });
        },
        editStudent( studentID )
        {
            this.$router.push({
                name: 'students-edit',
                params: {
                    id: studentID
                }
            });
        },
        select() {
			this.$refs.ig_inputfile.click();
		},
        async setFromPc()
        {
			this.uploading = true;
            var formData = new FormData();
			formData.append( 'files', this.$refs.ig_inputfile.files[0] );

			var config = { headers: {
                'Content-Type': 'multipart/form-data' ,
                'X-Fluke': this.$cookies.get('token')
            } };

            var result = await axios.post(
                this.$myServerAddresses.courses + 'students/upload_sheet',
                formData,
                config
            )

            if( result.data.success )
            {
                this.get();

                this.$store.commit(
                    'flash_success',
                    'Base de dados enviada com sucesso!'
                );
            }

            this.$refs.ig_inputfile.value = '';
        },
        getFilteredItems(e)
        {
            console.log(e);
        }
    }
}
</script>
